import { Table, message } from "antd";

import _ from "lodash";
import { useState } from "react";
import { deleteCharge, getAllCharges } from "../../helpers/api";
import { Chip, Modal, Select, Badge } from "@mantine/core";
import smallTalk from "smalltalk";
import { useQuery } from "react-query";
import NewChargeForm from "./components/new-charge";
import EditChargeForm from "./components/edit-charge";
import { getUser } from "../../helpers/auth";
import { CHARGE_VALUE_TYPES } from "../../helpers/config";

const ChargesPage = () => {
  const user = getUser();
  // states
  const [filteredData, setFilteredData] = useState([]);
  const [modal, setModal] = useState({
    isOpen: false,
    title: "",
    content: null,
    // zIndex
  });

  // queries
  const {
    data: charges,
    isFetching,
    refetch,
  } = useQuery({
    queryFn: () => getAllCharges(user.facility.id),
    queryKey: ["charges"],
    onSuccess: (data) => setFilteredData(data),
  });

  // handlers
  const handleReset = () => setFilteredData(charges);

  const handleDelete = (id) => {
    smallTalk
      .confirm("Delete Charge", "This action is irreversible. Continue?", {
        buttons: {
          ok: "YES",
          cancel: "NO",
        },
      })
      .then(() => {
        message.loading("deleting...");
        deleteCharge(user.facility.id, id).then((res) => {
          message.success("done!");
          refetch();
        });
      })
      .catch((ex) => message.error("no action taken"));
  };

  // charges table
  const columns = [
    {
      title: "Title",
      sorter: (a, b) => a?.title > b?.title,
      sortDirections: ["descend", "ascend"],
      render: (text, record, index) => <span>{record?.title}</span>,
    },

    {
      title: "Value Type",
      width: 130,
      sorter: (a, b) => a?.valueType > b?.valueType,
      sortDirections: ["descend", "ascend"],
      render: (text, record, index) => (
        <Badge
          color={record?.valueType === "fixed" ? "teal" : "violet"}
          variant="light">
          {CHARGE_VALUE_TYPES.find((c) => c.value === record?.valueType)?.label}
        </Badge>
      ),
    },
    {
      title: "Value",
      width: 120,
      sorter: (a, b) => a?.value > b?.value,
      sortDirections: ["descend", "ascend"],
      render: (text, record, index) => (
        <span className="fw-bold">
          {record?.valueType === "percentage"
            ? `${record?.value}%`
            : `GHS ${record?.value}`}
        </span>
      ),
    },
    {
      title: "",
      width: 170,
      render: (text, record, index) => (
        <>
          <button
            className="button app-btn is-ghost "
            onClick={() =>
              setModal({
                title: "View/Edit Charge",
                content: <EditChargeForm onSuccess={refetch} id={record.id} />,
                isOpen: true,
              })
            }>
            <span className="bi bi-eye me-1"></span>
            View
          </button>
          <button
            className="button app-btn is-light text-danger is-ghost"
            onClick={() => {
              handleDelete(record.id);
            }}>
            <span className="bi bi-trash"></span>
          </button>
        </>
      ),
    },
  ];

  return (
    <>
      <Modal
        onClose={() => setModal({ ...modal, isOpen: false })}
        opened={modal.isOpen}
        title={modal.title}
        zIndex={50}>
        {modal.content}
      </Modal>
      <div className="d-flex justify-content-between">
        <div className="d-flex mb-3">
          <button
            className={`button app-btn btn-prim me-3`}
            onClick={() =>
              setModal({
                title: "Add Charge",
                content: <NewChargeForm onSuccess={refetch} />,
                isOpen: true,
              })
            }>
            <span className="bi bi-plus-circle me-2"></span>
            Add Charge
          </button>
        </div>

        <div div className="d-flex">
          <div>
            <Badge color="teal" variant="outline" size="lg" className="me-2">
              {filteredData?.length || 0}
            </Badge>
            Charges
          </div>
          <button
            onClick={handleReset}
            className="button app-btn btn-text ms-2 d-flex align-items-center">
            <span className="bi bi-arrow-clockwise me-2"></span>
            <span className="d-none d-md-inline"> Reset filters</span>
          </button>
          <button className="button app-btn" onClick={() => refetch()}>
            <span className="bi bi-cycle"></span>
            <span className="d-none d-md-inline">Refresh</span>
          </button>
        </div>
      </div>
      {/* Stats Cards */}
      {/* <div className="row mb-4">
        <div className="col-md-3 col-6 mb-3">
          <div className="card border-0">
            <div className="card-body text-center">
              <div className="text-primary mb-2">
                <span className="bi bi-currency-dollar fs-1"></span>
              </div>
              <h4 className="mb-1">{filteredData?.length || 0}</h4>
              <p className="text-muted mb-0">Total Charges</p>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-6 mb-3">
          <div className="card border-0">
            <div className="card-body text-center">
              <div className="text-success mb-2">
                <span className="bi bi-tag fs-1"></span>
              </div>
              <h4 className="mb-1">
                {filteredData?.filter((c) => c.type === "service")?.length || 0}
              </h4>
              <p className="text-muted mb-0">Service Charges</p>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-6 mb-3">
          <div className="card border-0">
            <div className="card-body text-center">
              <div className="text-warning mb-2">
                <span className="bi bi-receipt fs-1"></span>
              </div>
              <h4 className="mb-1">
                {filteredData?.filter((c) => c.type === "fee")?.length || 0}
              </h4>
              <p className="text-muted mb-0">Fee Charges</p>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-6 mb-3">
          <div className="card border-0">
            <div className="card-body text-center">
              <div className="text-info mb-2">
                <span className="bi bi-percent fs-1"></span>
              </div>
              <h4 className="mb-1">
                {filteredData?.filter((c) => c.valueType === "percentage")
                  ?.length || 0}
              </h4>
              <p className="text-muted mb-0">Percentage Charges</p>
            </div>
          </div>
        </div>
      </div> */}

      {/* Search and Filters */}
      <div className="row my-3">
        <div className="col-md-6 col-12 mb-3">
          <div className="field">
            <input
              className="input"
              onChange={(e) =>
                setFilteredData(
                  charges?.filter(
                    (c) =>
                      c?.title
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase()) ||
                      c?.value
                        .toString()
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                  )
                )
              }
              title="search here"
              placeholder="Search by title, description or amount"
            />
          </div>
        </div>
        <div className="col-md-3 col-6 mb-3">
          <select
            className="input"
            onChange={(e) => {
              if (e.target.value === "") {
                setFilteredData(charges);
              } else {
                setFilteredData(
                  charges?.filter((c) => c.valueType === e.target.value)
                );
              }
            }}>
            <option value="">All Value Types</option>
            <option value="fixed">Fixed Amount</option>
            <option value="percentage">Percentage</option>
          </select>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <Table
            columns={columns}
            // bordered
            className="border"
            dataSource={filteredData}
            rowKey={(record) => record.id}
            loading={isFetching}
          />
        </div>
      </div>
    </>
  );
};

export { ChargesPage };
